import Phaser from 'phaser'

export default class DashedLine extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     */
    constructor(scene, strokewidth, strokecolor, gapwidth, dashwidth)
    {
        super(scene);

        this.strokeWidth = strokewidth;
        this.strokeColor = strokecolor;
        this.gapWidth = gapwidth;
        this.dashWidth = dashwidth;
        this.dashShape = this.scene.add.graphics();
        this.add(this.dashShape);
    }

    drawBetween(startPt, endPt, time)
    {
        this.dashShape.clear();
        this.dashShape.lineStyle(this.strokeWidth, this.strokeColor);
        this.x = startPt.x;
        this.y = startPt.y;
        let dx = endPt.x - startPt.x;
        let dy = endPt.y - startPt.y;
        this.currentLineWidth = Math.sqrt(dx * dx + dy * dy);
        this.angle = Math.atan2(dy, dx) * 180 / Math.PI;
        this.drawLine(time);
    }

    drawLine(time)
    {
        let interval = (time == 0) ? 0 : time / (this.currentLineWidth / (this.dashWidth + this.gapWidth));
        let p = 0;
        let counter = 0;
        while (p < this.currentLineWidth)
        {
            this.scene.time.delayedCall(interval * counter, this.drawDash, [p], this);
            p += (this.dashWidth + this.gapWidth);
            counter++;
        }
    }

    drawDash(p)
    {
        this.dashShape.lineBetween(p, 0, p + this.dashWidth, 0);
    }
}